<template>
  <b-nav-item-dropdown v-if="localUserProfile.Permissions.includes('MYSSalesReporting2017Link') ||
                             localUserProfile.Permissions.includes('MYSOnline20172016Link')">
    <template slot="button-content">
      <span class="nav-large">
        <font-awesome-icon :icon="['fas', 'external-link-alt']" />
        {{ $t('Webportal.ExternalTools') }}
      </span>
      <span class="nav-small" v-b-tooltip.hover.nofade="toolTipDelay" :title="$t('Webportal.ExternalTools')">
        <font-awesome-icon :icon="['fas', 'external-link-alt']" />
      </span>
    </template>

    <b-dropdown-item v-if="true" href="/cockpit2020" target="_blank">Dashboard 2020</b-dropdown-item>
    <b-dropdown-item v-if="localUserProfile.Permissions.includes('MYSSalesReporting2017Link')" :href="`https://msmloop.com/Account/Login.aspx?ssoguid=${userProfile.sub}`" target="_blank">{{ $t('Webportal.MYSSalesReporting2017Link') }}</b-dropdown-item>
    <b-dropdown-item v-if="localUserProfile.Permissions.includes('MYSOnline20172016Link')" :href="`https://bmweleadsreporting.msmiq.com/Account/Login.aspx?UID=${userProfile.sub}`" target="_blank">{{ $t('Webportal.MYSOnline20172016Link') }}</b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'
import AppConfig from '@/mixins/AppConfig-APP_TARGET';

export default {
  name: "ExternalTools",

  mixins: [ AppConfig ],

  computed: {
    userProfile: function() {
      return AuthenticationService.userProfile;
    },

    localUserProfile: function() {
      return AuthenticationService.localUserProfile;
    }
  }
}
</script>
